// extracted by mini-css-extract-plugin
export default {"contentGroup":"vp_I79v8","title":"vp_Jy0hs","indicator":"vp_DRIZV","text":"vp_IK2Oy","counter":"vp_jILB0","content":"vp_qZqhZ","colorNote":"vp_EOZX6"};